/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
// import { DownOutlined, MenuOutlined } from "@ant-design/icons";
import {  Select, Table, Radio } from "antd";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import Api from "../../services/ServiceApi";

function buildFileSelector() {
  const fileSelector = document.createElement("input");
  fileSelector.setAttribute("type", "file");
  fileSelector.setAttribute("multiple", "multiple");
  return fileSelector;
}

const mapOptions = {
  disableDefaultUI: true,
  styles: [
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#e9e9e9",
        },
        {
          lightness: 17,
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5",
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 17,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 29,
        },
        {
          weight: 0.2,
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 18,
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5",
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: "#dedede",
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      elementType: "labels.text.stroke",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#ffffff",
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      elementType: "labels.text.fill",
      stylers: [
        {
          saturation: 36,
        },
        {
          color: "#333333",
        },
        {
          lightness: 40,
        },
      ],
    },
    {
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [
        {
          color: "#f2f2f2",
        },
        {
          lightness: 19,
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#fefefe",
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#fefefe",
        },
        {
          lightness: 17,
        },
        {
          weight: 1.2,
        },
      ],
    },
  ], // straight out of something like snazzymaps
};

const columns = [
  {
    title: "No.",
    dataIndex: "No",
    key: "No",
    sorter: (a, b) => a.No.length - b.No.length,
  },
  {
    title: "Code",
    dataIndex: "Code",
    key: "Code",
    sorter: (a, b) => a.Code.length - b.Code.length,
  },
  {
    title: "Problem Detail",
    dataIndex: "Problem_Detail",
    key: "Problem_Detail",
    sorter: (a, b) => a.Problem_Detail.length - b.Problem_Detail.length,
  },
  {
    title: "Unit",
    dataIndex: "Unit",
    key: "Unit",
    sorter: (a, b) => a.Unit.length - b.Unit.length,
  },
  {
    title: "Qty",
    dataIndex: "Qty",
    key: "Qty",
    sorter: (a, b) => a.Qty.length - b.Qty.length,
  },
  {
    title: "Price",
    dataIndex: "Price",
    key: "Price",
    sorter: (a, b) => a.Price.length - b.Price.length,
  },
  {
    title: "Req.By",
    dataIndex: "Req_By",
    key: "Req_By",
  },
  {
    title: "Action",
    dataIndex: "Action",
    key: "Action",
    render: (item) => (
      <div>
        {item == 0 ? (
          <span></span>
        ) : (
          <span className="c-green">
            <span className="dot-active mr-2"></span>Active
          </span>
        )}
      </div>
    ),
  },
];
const Macolumns = [
  {
    title: "No.",
    dataIndex: "No",
    key: "No",
    sorter: (a, b) => a.No.length - b.No.length,
  },
  {
    title: "Team group",
    dataIndex: "Team_group",
    key: "Team_group",
    sorter: (a, b) => a.Team_group.length - b.Team_group.length,
  },
  {
    title: "Team",
    dataIndex: "Team",
    key: "Team",
    sorter: (a, b) => a.Team.length - b.Team.length,
  },
  {
    title: "Work date",
    dataIndex: "Work_date",
    key: "Work_date",
    sorter: (a, b) => a.Work_date.length - b.Work_date.length,
  },
  {
    title: "Finish date",
    dataIndex: "Finish_date",
    key: "Finish_date",
    sorter: (a, b) => a.Finish_date.length - b.Finish_date.length,
  },
  {
    title: "Problem Type",
    dataIndex: "Problem_Type",
    key: "Problem_Type",
    sorter: (a, b) => a.Problem_Type.length - b.Problem_Type.length,
  },
  {
    title: "Problem Detail",
    dataIndex: "Problem_Detail",
    key: "Problem_Detail",
    sorter: (a, b) => a.Problem_Detail.length - b.Problem_Detail.length,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Action",
    dataIndex: "Action",
    key: "Action",
    render: (item) => (
      <div>
        {item == 0 ? (
          <span></span>
        ) : (
          <span className="c-green">
            <span className="dot-active mr-2"></span>Active
          </span>
        )}
      </div>
    ),
  },
];

const MyMapComponent = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap
      defaultZoom={8}
      defaultCenter={{ lat: -34.397, lng: 150.644 }}
      options={mapOptions}
    >
      {props.isMarkerShown && (
        <Marker
          position={{ lat: -34.397, lng: 150.644 }}
          icon="/icon/pin_job_high.png"
        />
      )}
    </GoogleMap>
  ))
);

class Addjob extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      title: "ADD JOB",
      statusbtn: "Asset",
      showMenu: false,
      data: [
        { value: 0, text: "Install" },
        { value: 1, text: "Repair" },
        { value: 2, text: "Retern" },
        { value: 3, text: "Hardware" },
        { value: 4, text: "Software" },
        { value: 5, text: "Electrical System" },
        { value: 6, text: "Network" },
        { value: 7, text: "CCTV" },
        { value: 8, text: "Photograp" },
      ],
      startDate: new Date(),
      options: [
        { label: "00:00-06:00", value: 1 },
        { label: "06:00-12:00", value: 2 },
        { label: "12:00-13:00", value: 3 },
        { label: "13:00-18:00", value: 4 },
        { label: "18:00:24:00", value: 5 },
      ],
      datatable: [
        {
          No: "1",
          Code: "DGT BTS-00",
          Problem_Detail: "Digital Signage BTS 01",
          Unit: "07/01/2019 18.00",
          Qty: "chanakarn_r",
          Price: "DGT BTS-00",
          Req_By: "Digital Signage BTS 01",
          Action: "07/01/2019 18.00",
        },
        {
          No: "2",
          Code: "DGT BTS-00",
          Problem_Detail: "Digital Signage BTS 01",
          Unit: "07/01/2019 18.00",
          Qty: "chanakarn_r",
          Price: "DGT BTS-00",
          Req_By: "Digital Signage BTS 01",
          Action: "07/01/2019 18.00",
        },
        {
          No: "3",
          Code: "DGT BTS-00",
          Problem_Detail: "Digital Signage BTS 01",
          Unit: "07/01/2019 18.00",
          Qty: "chanakarn_r",
          Price: "DGT BTS-00",
          Req_By: "Digital Signage BTS 01",
          Action: "07/01/2019 18.00",
        },
      ],
      datatableMa: [
        {
          No: "1",
          Team_group: "DGT BTS-00",
          Team: "Digital Signage BTS 01",
          Work_date: "07/01/2019 18.00",
          Finish_date: "chanakarn_r",
          Problem_Type: "DGT BTS-00",
          Problem_Detail: "Digital Signage BTS 01",
          status: "OK",
        },
        {
          No: "2",
          Team_group: "DGT BTS-00",
          Team: "Digital Signage BTS 01",
          Work_date: "07/01/2019 18.00",
          Finish_date: "chanakarn_r",
          Problem_Type: "DGT BTS-00",
          Problem_Detail: "Digital Signage BTS 01",
          status: "OK",
        },
        {
          No: "3",
          Team_group: "DGT BTS-00",
          Team: "Digital Signage BTS 01",
          Work_date: "07/01/2019 18.00",
          Finish_date: "chanakarn_r",
          Problem_Type: "DGT BTS-00",
          Problem_Detail: "Digital Signage BTS 01",
          status: "OK",
        },
      ],
    };

    this.fileSelector = buildFileSelector();
  }

  componentDidMount() {
    document.title = "MaxiOperation - Add Job";
  }

  btntype(n) {
    this.setState({ statusbtn: n });
  }

  buildFileSelector() {
    const fileSelector = document.createElement("input");
    fileSelector.setAttribute("type", "file");
    fileSelector.setAttribute("multiple", "multiple");
    return fileSelector;
  }

  handleFileSelect = (e) => {
    e.preventDefault();
    this.fileSelector.click();
  };

  toggleDropdown() {
    this.setState({
      active: !this.state.active,
    });
  }
  handleChange = (date) => {
    this.setState({
      startDate: date,
    });
  };
  onChange = (e) => {
    console.log("radio checked", e.target.value);
    this.setState({
      value: e.target.value,
    });
  };
  render() {
    const {
      loading,
      title,
      statusbtn,
      data,
      startDate,
      options,
      datatable,
      datatableMa,
    } = this.state;

    return (
      <LayoutOperation title={title}>
        {/*  ============================== Header Page  ==============================*/}

        <div className="row mb-2">
          <div className="col-sm-6 mt-3 ">
            <a
              href="#"
              className="ml-5  text-dark"
              style={{ color: "#2B2D33", fontSize: "18px", textAlign: "left" }}
            >
              {" "}
              {"< "} Back
            </a>
          </div>
          <div className="col-sm-6">
            <ol
              className="breadcrumb float-sm-right mr-5  mt-3"
              style={{ background: "inherit" }}
            >
              <li className="breadcrumb-item">MA List</li>
              <li className="breadcrumb-item">
                <a href="#"> RECORD PROBLEM </a>
              </li>
            </ol>
          </div>
        </div>
        {/*  ==============================  Page  Body ==============================*/}
        <div className="container mb-2">
          <div className="row">
            <div className="col-12 mt-2 ">
              <span style={{ color: "#0500A3", fontSize: "16px" }}>
                <img
                  src={Api.absoluteUrl("/icon/pust.svg")}
                  width="14"
                  className="mr-2"
                />
                <b> RECORD PROBLEM </b>
              </span>
              <div className="card mt-2">
                <div className="card-body">
                  <div style={{ textAlign: "center" }}>
                    <button
                      type="button"
                      className={
                        this.state.statusbtn == "Asset"
                          ? "btnrecordshow"
                          : "btnrecordhide"
                      }
                      onClick={this.btntype.bind(this, "Asset")}
                    >
                      <span style={{ marginLeft: "-20px", fontSize: "18px" }}>
                        1. Job and Asset Detail
                      </span>
                    </button>
                    <button
                      type="button"
                      className={
                        this.state.statusbtn == "Problem"
                          ? "btnrecordshow ml-3"
                          : "btnrecordhide ml-3"
                      }
                      onClick={this.btntype.bind(this, "Problem")}
                    >
                      <span style={{ marginLeft: "-20px", fontSize: "18px" }}>
                        2. Problem Detail
                      </span>
                    </button>
                    <button
                      type="button"
                      className={
                        this.state.statusbtn == "Reviewsubmit"
                          ? "btnrecordshow ml-3"
                          : "btnrecordhide ml-3"
                      }
                      onClick={this.btntype.bind(this, "Reviewsubmit")}
                    >
                      <span style={{ marginLeft: "-20px", fontSize: "18px" }}>
                        3. Review and submit
                      </span>
                    </button>
                  </div>
                  <hr />

                  {/* ========================================  Job and Asset Detail ===================================== */}
                  <div
                    className={
                      this.state.statusbtn == "Asset"
                        ? "mt-2   divshow"
                        : "mt-2 divhide"
                    }
                  >
                    <div className="row">
                      <div className="col-3"> </div>

                      <div className="col-7">
                        <img
                          style={{
                            float: "left",
                            marginTop: "7px",
                            marginRight: "10px",
                          }}
                          src={Api.absoluteUrl("/icon/setting.svg")}
                        />
                        <span className="jobdetail">
                          {" "}
                          Job Detail and Location{" "}
                        </span>
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Job Id
                            </label> <br />{" "}
                            <input type="text" className="inputfile"></input>
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">Job Type</label>{" "}
                            <br />{" "}
                            <Select defaultValue="" className="dropdrowtype">
                              <Select.Option value="" disabled>
                                Please select
                              </Select.Option>
                              {this.state.data.map((item, index) => (
                                <Select.Option key={index} value={item.value}>
                                  {item.text}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Inform Person
                            </label>{" "}
                            <br />{" "}
                            <input type="text" className="inputfile"></input>
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Tel
                            </label> <br />{" "}
                            <input type="text" className="inputfile"></input>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Priority <b style={{ color: "#DF4547" }}> * </b>
                            </label>{" "}
                            <br />{" "}
                            <Radio.Group
                              onChange={this.onChange}
                              value={this.state.value}
                            >
                              <Radio value={1} className="mt-2">
                                {" "}
                                <img
                                  src={Api.absoluteUrl("/icon/urgent.svg")}
                                  style={{
                                    marginLeft: "10px",
                                    marginTop: "-10px;",
                                  }}
                                  className="mr-2"
                                />{" "}
                              </Radio>
                              <br />
                              <Radio value={2} className="mt-2">
                                {" "}
                                <img
                                  src={Api.absoluteUrl("/icon/high.svg")}
                                  style={{
                                    marginLeft: "10px",
                                    marginTop: "-10px;",
                                  }}
                                  className="mr-2"
                                />{" "}
                              </Radio>
                              <br />
                              <Radio value={3} className="mt-2">
                                {" "}
                                <img
                                  src={Api.absoluteUrl("/icon/normal.svg")}
                                  style={{
                                    marginLeft: "10px",
                                    marginTop: "-10px;",
                                  }}
                                  className="mr-2"
                                />
                              </Radio>
                              <br />
                              <Radio value={4} className="mt-2">
                                {" "}
                                <img
                                  src={Api.absoluteUrl("/icon/low.svg")}
                                  className="mr-2"
                                  style={{
                                    marginLeft: "10px",
                                    marginTop: "-10px;",
                                  }}
                                />
                              </Radio>
                            </Radio.Group>{" "}
                          </div>
                          <div className="col-6"></div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Area Code <b style={{ color: "#DF4547" }}> * </b>
                            </label>{" "}
                            <br />{" "}
                            <Select defaultValue="" className="dropdrowtype">
                              <Select.Option value="" disabled>
                                Please input
                              </Select.Option>
                              {this.state.data.map((item, index) => (
                                <Select.Option key={index} value={item.value}>
                                  {item.text}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Sub Code Area
                            </label>{" "}
                            <br />{" "}
                            <Select defaultValue="" className="dropdrowtype">
                              <Select.Option value="" disabled>
                                Please input
                              </Select.Option>
                              {this.state.data.map((item, index) => (
                                <Select.Option key={index} value={item.value}>
                                  {item.text}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Location Name
                            </label>{" "}
                            <br />{" "}
                            <input type="text" className="inputfile"></input>
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Lat / Long
                            </label>{" "}
                            <br />{" "}
                            <input type="text" className="inputfile"></input>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-12">
                            <MyMapComponent
                              isMarkerShown
                              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCTm1QKX4uGPhsUqkF2-TfZXyH4lr-P1Vs&v=3.exp&libraries=geometry,drawing,places"
                              loadingElement={
                                <div style={{ height: `100%` }} />
                              }
                              containerElement={<div />}
                              mapElement={<div style={{ height: `253px` }} />}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-3"> </div>

                      <div className="col-7">
                        <img
                          style={{
                            float: "left",
                            marginTop: "7px",
                            marginRight: "10px",
                          }}
                          src={Api.absoluteUrl("/icon/Asset.svg")}
                        />
                        <span className="jobdetail"> Asset Detail </span>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Asset Name <b style={{ color: "#DF4547" }}> * </b>
                            </label>{" "}
                            <br />{" "}
                            <input type="text" className="inputfile"></input>
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Group Type <b style={{ color: "#DF4547" }}> * </b>
                            </label>{" "}
                            <br />{" "}
                            <Select defaultValue="" className="dropdrowtype">
                              <Select.Option value="" disabled>
                                Please select
                              </Select.Option>
                              {this.state.data.map((item, index) => (
                                <Select.Option key={index} value={item.value}>
                                  {item.text}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Asset Type <b style={{ color: "#DF4547" }}> * </b>
                            </label>{" "}
                            <br />{" "}
                            <Select defaultValue="" className="dropdrowtype">
                              <Select.Option value="" disabled>
                                Please select
                              </Select.Option>
                              {this.state.data.map((item, index) => (
                                <Select.Option key={index} value={item.value}>
                                  {item.text}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Asset Sub Type{" "}
                              <b style={{ color: "#DF4547" }}> * </b>
                            </label>{" "}
                            <br />{" "}
                            <Select defaultValue="" className="dropdrowtype">
                              <Select.Option value="" disabled>
                                Please select
                              </Select.Option>
                              {this.state.data.map((item, index) => (
                                <Select.Option key={index} value={item.value}>
                                  {item.text}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr />
                    <div style={{ textAlign: "center" }} className="mt-5">
                      <button type="button" class="btnbrows">
                        <span style={{ fontSize: "16px" }}>Next</span>
                      </button>
                    </div>
                  </div>
                  {/* ==================================================================================================== */}

                  {/* ========================================  Problem Detail =========================================== */}
                  <div
                    className={
                      this.state.statusbtn == "Problem"
                        ? "mt-2   divshow"
                        : "mt-2 divhide"
                    }
                  >
                    <div className="row">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <img
                          style={{
                            float: "left",
                            marginTop: "7px",
                            marginRight: "10px",
                          }}
                          src={Api.absoluteUrl("/icon/problem_icon.svg")}
                        />
                        <span className="jobdetail"> Problem Detail </span>
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Assign date
                            </label>{" "}
                            <br />{" "}
                            <DatePicker
                              className="datepicker"
                              selected={this.state.startDate}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="col-6"></div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Problem detail
                            </label>{" "}
                            <br />{" "}
                            <textarea
                              style={{ width: "100%", height: "80px" }}
                            ></textarea>
                          </div>
                          <div className="col-6"></div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Remark
                            </label> <br />{" "}
                            <textarea
                              style={{ width: "100%", height: "80px" }}
                            ></textarea>
                          </div>
                          <div className="col-6"></div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-3"> </div>

                      <div className="col-7">
                        <img
                          style={{
                            float: "left",
                            marginTop: "7px",
                            marginRight: "10px",
                          }}
                          src={Api.absoluteUrl("/icon/service.svg")}
                        />
                        <span className="jobdetail">
                          {" "}
                          MA Service officer TEAM{" "}
                        </span>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              MA team group*
                            </label>{" "}
                            <br />{" "}
                            <input type="text" className="inputfile"></input>
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">MA Team*</label>{" "}
                            <br />{" "}
                            <Select defaultValue="" className="dropdrowtype">
                              <Select.Option value="" disabled>
                                Please input
                              </Select.Option>
                              {this.state.data.map((item, index) => (
                                <Select.Option key={index} value={item.value}>
                                  {item.text}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">Work date</label>{" "}
                            <br />{" "}
                            <DatePicker
                              className="datepicker"
                              selected={this.state.startDate}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Finish date
                            </label>{" "}
                            <br />{" "}
                            <DatePicker
                              className="datepicker"
                              selected={this.state.startDate}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Status
                            </label> <br />{" "}
                            <Select defaultValue="" className="dropdrowtype">
                              <Select.Option value="" disabled>
                                Please input
                              </Select.Option>
                              {this.state.data.map((item, index) => (
                                <Select.Option key={index} value={item.value}>
                                  {item.text}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                          <div className="col-6"></div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">Url File</label>{" "}
                            <br />{" "}
                            <input type="text" className="inputfile"></input>
                          </div>
                          <div className="col-6"></div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="row mt-3"
                      style={{ background: "#0500A3", height: "40px" }}
                    >
                      <div className="col-5" style={{ marginTop: "5px" }}>
                        <span style={{ color: "#FFFFFF", fontSize: "18px" }}>
                          MA Expense
                        </span>
                      </div>
                      <div className="col-5"></div>
                      <div
                        className="col-2"
                        style={{ textAlign: "right", marginTop: "5px" }}
                      >
                        <button type="button" class="btnbrows">
                          <span style={{ fontSize: "16px" }}>Add</span>
                        </button>
                      </div>
                    </div>
                    <Table
                      columns={columns}
                      dataSource={datatable}
                      pagination={false}
                    />

                    <hr />
                    <div style={{ textAlign: "center" }} className="mt-5">
                      <button
                        type="button"
                        class="btnPrevious"
                        style={{ marginRight: "30%" }}
                      >
                        <span style={{ fontSize: "16px" }}>Previous</span>
                      </button>
                      <button type="button" class="btnbrows">
                        <span style={{ fontSize: "16px" }}>Next</span>
                      </button>
                    </div>
                  </div>
                  {/* ==================================================================================================== */}

                  {/* ========================================  Review and submit =========================================== */}
                  <div
                    className={
                      this.state.statusbtn == "Reviewsubmit"
                        ? "mt-2   divshow"
                        : "mt-2 divhide"
                    }
                  >
                    <div className="row">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <img
                          style={{
                            float: "left",
                            marginTop: "7px",
                            marginRight: "10px",
                          }}
                          src={Api.absoluteUrl("/icon/setting.svg")}
                        />
                        <span className="jobdetail">
                          {" "}
                          Job Detail and Location{" "}
                        </span>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Job ID</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">
                              BKK_235234623
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Job Type</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">Hardware</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Inform Person</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">K.Nita</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Tel</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">088-123-4567</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Priority</label>
                          </div>
                          <div className="col-4">
                            <img src={Api.absoluteUrl("/icon/urgent.svg")} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">
                              Area Code <b style={{ color: "#DF4547" }}> * </b>
                            </label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">BKK01</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Sub Code Area</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">BKK01_N034</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Location Name</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">
                              ลานน้ำพุ สยามพารากอน
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Lat / Long</label>
                          </div>
                          <div className="col-8">
                            <label className="labelddetail">
                              19.8547854785253000045 / 19.8547854785253000045
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4"></div>
                          <div className="col-6">
                            <MyMapComponent
                              isMarkerShown
                              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCTm1QKX4uGPhsUqkF2-TfZXyH4lr-P1Vs&v=3.exp&libraries=geometry,drawing,places"
                              loadingElement={
                                <div
                                  style={{ height: `100%`, width: "100%" }}
                                />
                              }
                              containerElement={<div />}
                              mapElement={<div style={{ height: `153px` }} />}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <img
                          style={{
                            float: "left",
                            marginTop: "7px",
                            marginRight: "10px",
                          }}
                          src={Api.absoluteUrl("/icon/Asset.svg")}
                        />
                        <span className="jobdetail"> Asset Detail </span>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Asset Name</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">
                              Digital Signage LED
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Group Type</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">
                              Digital Signage LED
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Asset Type</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">Digital MRT</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">
                              Asset Sub Type
                            </label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">LED</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <img
                          style={{
                            float: "left",
                            marginTop: "7px",
                            marginRight: "10px",
                          }}
                          src={Api.absoluteUrl("/icon/problem_icon.svg")}
                        />
                        <span className="jobdetail"> Problem Detail </span>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Assign date</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">30/01/2013</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">
                              Problem detail
                            </label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">
                              Problem detail
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Remark</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">-</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <img
                          style={{
                            float: "left",
                            marginTop: "7px",
                            marginRight: "10px",
                          }}
                          src={Api.absoluteUrl("/icon/problem_icon.svg")}
                        />
                        <span className="jobdetail"> MA Detail </span>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">MA team group</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">BKK01_N10</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">MA Team</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">Team BKK10</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Work date</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">30/01/2013</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Finish date</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">30/01/2013</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">Status</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail">transfer job</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-4">
                            <label className="labelheader">URL File</label>
                          </div>
                          <div className="col-4">
                            <label className="labelddetail"></label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr />
                    <div style={{ textAlign: "center" }} className="mt-5">
                      <button
                        type="button"
                        class="btnPrevious"
                        style={{ marginRight: "30%" }}
                      >
                        <span style={{ fontSize: "16px" }}>Previous</span>
                      </button>
                      <button type="button" class="btnbrows">
                        <span style={{ fontSize: "16px" }}>Submit</span>
                      </button>
                    </div>
                  </div>
                  {/* ==================================================================================================== */}
                </div>
              </div>
            </div>
          </div>

          {/* ========================================  Problem Table =========================================== */}
          <div
            className={
              this.state.statusbtn == "Problem"
                ? "divshow card mt-3"
                : "divhide card mt-3"
            }
          >
            <div className="card-body">
              <div
                className="row"
                style={{ background: "#E8ECEF", height: "40px" }}
              >
                <div className="col-5" style={{ marginTop: "5px" }}>
                  <span style={{ color: "#0500A3", fontSize: "18px" }}>
                    MA Record history
                  </span>
                </div>
                <div className="col-5"></div>
                <div
                  className="col-2"
                  style={{ textAlign: "right", marginTop: "5px" }}
                ></div>
              </div>
              <div style={{ textAlign: "center" }}>
                <Table
                  columns={Macolumns}
                  dataSource={datatableMa}
                  pagination={false}
                />
              </div>
            </div>
          </div>
          {/* ==================================================================================================== */}
        </div>
      </LayoutOperation>
    );
  }
}

export default Addjob;
